import React from "react";
import "./HomeLeaveRequests.css";

function UpcomingLeaveCard({ leave }) {
  return (
    <article className="ess-upcoming-leave-card">
      <div className="ess-upcoming-leave-top">
        <h3 className="ess-upcoming-leave-type">{leave.type}</h3>
        <span className="ess-status-badge ess-status-approved">
          {leave.statusLabel}
        </span>
      </div>
      <p className="ess-upcoming-leave-note">{leave.note}</p>
      <dl className="ess-upcoming-leave-meta">
        <div>
          <dt>من</dt>
          <dd>{leave.startDate || "—"}</dd>
        </div>
        <div>
          <dt>إلى</dt>
          <dd>{leave.endDate || "—"}</dd>
        </div>
        {leave.days ? (
          <div>
            <dt>الأيام</dt>
            <dd>{leave.days} يوم</dd>
          </div>
        ) : null}
      </dl>
    </article>
  );
}

/** Only upcoming/ongoing approved leave — not a duplicate request list. */
export default function HomeLeaveRequests({ requests = [] }) {
  if (!requests.length) return null;

  return (
    <section className="ess-table-card ess-home-leave-section" dir="rtl">
      <div className="ess-home-section-head">
        <h2 className="ess-table-title">إجازة قادمة</h2>
        <p className="ess-home-section-sub">إجازة معتمدة جارية أو هتبدأ قريب</p>
      </div>
      <div className="ess-upcoming-leave-list">
        {requests.map((leave) => (
          <UpcomingLeaveCard key={leave.id} leave={leave} />
        ))}
      </div>
    </section>
  );
}
